import {
  AppBar,
  Tabs,
  Tab,
  Icon,
  Grid,
  Hidden,
  Typography,
  CircularProgress,
  Box,
} from "@material-ui/core";
import "./style.scss";

import { FormLoginContainer, Form, Translator } from "@itarget/shared";

import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Footer from "../../../components/Footer/Footer";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles(() => ({
  loginForm: {
    backgroundColor: (props) =>
      props.theme == "light" ? "#f6f6f6" : "#232323",
    padding: "20px",
    borderRadius: "10px",
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      className="tabPanel-div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

const LoginView = ({
  value,
  handleChange,
  setting,
  bottomRegister,
  auth,
  toast,
  settingCommerce,
  isLoadingService,
  isLoadingSettingLogin,
}) => {
  const systemTheme = useSelector((state) => state.theme.systemTheme);
  const styles = useStyles({ theme: systemTheme });
  const { cc } = useParams();
  const centerCostId = useSelector((state) => state.auth.cc);
  const settingCourse = useSelector((state) => state.setting.settingCommerce);
  let selectedCenterCostId = cc || centerCostId;

  const label = {
    hasLogin: Translator({
      transRef: "translation.Tenho Login",
    }),
    newRegister: Translator({
      transRef: "translation.Novo Cadastro",
    }),
    login: Translator({
      transRef: "translation.Login",
    }),
  };

  const canRegister = ["S", undefined, false].includes(bottomRegister);

  const loginBackgroundStyle = {
    backgroundImage: `url(${settingCommerce?.url_image_login_background})`,
    backgroundPosition: "left top",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  };

  if (isLoadingService || isLoadingSettingLogin) {
    return (
      <Box
        height="100vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <CircularProgress />
        <Footer />
      </Box>
    );
  }

  return (
    <div
      className="login-container"
      style={
        settingCommerce?.url_image_login_background ? loginBackgroundStyle : {}
      }
    >
      {settingCommerce?.url_image_login && (
        <Grid style={{ padding: "15px" }}>
          {!isLoadingService && (
            <img
              className="img-logo"
              src={settingCommerce?.url_image_login}
              width="100%"
              alt="logo"
            />
          )}
        </Grid>
      )}
      <Grid className={`login-form ${styles.loginForm}`}>
        {!isLoadingSettingLogin && canRegister && (
          <AppBar position="static" color="default">
            <Tabs
              value={value}
              onChange={handleChange}
              textColor="primary"
              variant="fullWidth"
              className="tabs-login"
            >
              <Tab
                className="tab-item tab-login"
                icon={<Icon>how_to_reg</Icon>}
                label={label.hasLogin}
              />
              <Tab
                className="tab-item tab-register"
                icon={<Icon>person_add</Icon>}
                label={label.newRegister}
              />
            </Tabs>
          </AppBar>
        )}

        {!isLoadingSettingLogin && !canRegister && (
          <Typography className="form-title">{label.login}</Typography>
        )}

        <TabPanel className="tab-loginForm" value={value} index={0}>
          <Grid>
            <FormLoginContainer
              tipo_interface_id={109}
              auth={auth}
              centro_custo_id={selectedCenterCostId}
              setting={setting}
              redirect={`recovery-login${
                settingCourse?.centro_custo_padrao
                  ? `/${selectedCenterCostId}`
                  : ""
              }`}
              backGroundColorLogin="#35446B"
              colorLogin="#fff"
            />
          </Grid>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Form
            auth={auth}
            toast={toast}
            centro_custo_id={selectedCenterCostId}
            tipo_interface_id={109}
            description={false}
            rules={true}
          />
        </TabPanel>
      </Grid>
      <Footer />
    </div>
  );
};

export default LoginView;
